import { Image, useBreakpointValue } from '@chakra-ui/react'

import Logo from 'modules/common/assets/images/logo.svg'
import VerticalLogo from 'modules/common/assets/images/vertical-logo.svg'

export const ResponsiveLogo = () => {
	const isMobile = useBreakpointValue({ base: true, sm: false, md: false, lg: false})

	if (isMobile) return <Image src={VerticalLogo} alt='Logotipo da plataforma conecta pne' />

	return <Image src={Logo} alt='Logotipo da plataforma conecta pne' />
}